import request from '@/utils/request'

/**
 * 获取商户信息列表
 * @param {Object} params - 查询参数
 * @returns {Promise} 返回商户信息列表
 */
export function getStoreInfo(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/listStoreManage.getStoreInfo',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新商户基本信息
 * @param {Object} data - 更新数据
 * @returns {Promise} 返回更新结果
 */
export function updateStoreInfo(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/updateStoreInfo.updateStoreInfo',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新商户属性信息
 * @param {Object} data - 更新数据
 * @returns {Promise} 返回更新结果
 */
export function updateStoreAttr(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeAttr.updateStoreAttr',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}